/* SYNCED from shotbook-landing/src/components/ui/VisuallyHidden.tsx — не править руками, запускать npm run sync:ds */
import type { ReactNode } from 'react';
import utils from '@/styles/utils.module.css';

export function VisuallyHidden({ children }: { children: ReactNode }) {
  return <span className={utils.visuallyHidden}>{children}</span>;
}
